import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { IoIosEye, IoIosEyeOff } from "react-icons/io";
import {
  changePassword,
  resetAuthState,
} from "../../core/data/redux/authSlice";
import { handleModalAction } from "../../utils/helpers/handleModalAction";

const ChangePassword = () => {
  const dispatch = useDispatch();
  const { status, user } = useSelector((state) => state.auth);

  const [passwordVisibility, setPasswordVisibility] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const toggleVisibility = (field) => {
    setPasswordVisibility((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const formik = useFormik({
    initialValues: {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      currentPassword: Yup.string().required("Current Password is required"),
      newPassword: Yup.string()
        .required("New Password is required")
        .min(6, "Password must be at least 6 characters"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("newPassword"), ""], "Passwords must match")
        .required("Confirm Password is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const resultAction = await dispatch(changePassword(values));

      if (changePassword.fulfilled.match(resultAction)) {
        handleModalAction("change_password", "hide");
        toast.success("Password changed successfully!");
        resetForm();
        dispatch(resetAuthState());
      } else {
        toast.error(resultAction.payload || "Password change failed.");
      }
    },
  });

  return (
    <div>
      {/* Change Password Modal */}
      <div className="modal fade" id="change_password" role="dialog">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Change Password</h5>
              <button
                className="btn-close custom-btn-close border p-1 me-0 text-dark"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className="modal-body">
                {["currentPassword", "newPassword", "confirmPassword"].map(
                  (field, index) => (
                    <div key={index} className="mb-3 position-relative">
                      <label className="col-form-label">
                        {field === "currentPassword"
                          ? "Current Password"
                          : field === "newPassword"
                          ? "New Password"
                          : "Confirm Password"}
                        <span className="text-danger">*</span>
                      </label>
                      <div className="input-group">
                        <input
                          type={passwordVisibility[field] ? "text" : "password"}
                          className={`form-control ${
                            formik.touched[field] && formik.errors[field]
                              ? "is-invalid"
                              : ""
                          }`}
                          name={field}
                          value={formik.values[field]}
                          onChange={formik.handleChange}
                          onBlur={formik.handleBlur}
                          required
                        />
                        <button
                          type="button"
                          className="btn btn-light fs-5"
                          onClick={() => toggleVisibility(field)}
                        >
                          {passwordVisibility[field] ? (
                            <IoIosEye />
                          ) : (
                            <IoIosEyeOff />
                          )}
                        </button>
                        {formik.touched[field] && formik.errors[field] && (
                          <div className="invalid-feedback">
                            {formik.errors[field]}
                          </div>
                        )}
                      </div>
                    </div>
                  )
                )}
              </div>

              <div className="modal-footer">
                <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                  Cancel
                </Link>
                <button
                  type="submit"
                  className="btn btn-primary"
                  disabled={status === "loading"}
                  data-bs-dismiss={`${status === "success" ? "modal" : ""}`}
                >
                  {status === "loading" ? "Saving..." : "Save"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
